// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"SurveyReport_closeButton__2_uMA"};